import { DataGrid } from "@mui/x-data-grid";
import styled from "styled-components";


export const Table = styled(DataGrid)`
    width: 100%;
    max-width: none!important;
`;